import { api, datesToISO, formHeaders } from "@";
import { processGiftCardAttributes, searchValuesPayload } from "./helpers";

// Fetch gift projects with search and pagination
export const getGiftProjects = (page = 1, perSize = "", search = {}) => {
  return api.post(
    `/api/adminGiftProject/gift-projects/dashboard-search?Page=${page}&PageSize=${perSize}`,
    searchValuesPayload(search),
  );
};

// Toggle active status of a gift project
export const toggleActive = (id, value) =>
  api.put(
    `/api/adminGiftProject/gift-projects/${id}/change-active-status?isActive=${value}`,
  );

// Toggle archive status of a gift project
export const toggleArchive = (id, value) =>
  api.put(
    `/api/adminGiftProject/gift-projects/${id}/change-archived-status?isArchived=${value}`,
  );

// Fetch a single gift project by ID
export const getGiftProject = (id) => {
  if (id) {
    return api.get(`/api/adminGiftProject/gift-projects/${id}`);
  }
};

// Save a new gift project
export const saveGiftProject = (data) => {
  data.startsFrom = datesToISO(data.startsFrom) || "";
  data.endsTo = datesToISO(data.endsTo) || "";

  const formData = new FormData();

  // Append non-attribute fields to formData
  for (let key in data) {
    if (key.includes("attribute")) {
      continue;
    }
    formData.append(key, data[key]);
  }

  // Append attribute fields to formData
  for (let i = 0; i < data.attributes.length; i++) {
    let el = data.attributes[i];
    formData.append(`attributes[${i}].title`, el.title);
    formData.append(`attributes[${i}].price`, el.amount);
    const file = el.image ? el.image : null;
    formData.append(`attributes[${i}].image`, file);
  }

  // Remove temporary fields from data
  ["attributeTitle", "attributeAmount", "attributeImage"].forEach(
    (field) => delete data[field],
  );

  return api.post("/api/adminGiftProject/gift-projects", formData, formHeaders);
};

// Update an existing gift project
export const updateGiftProject = async (data) => {
  data.startsFrom = datesToISO(data.startsFrom) || "";
  data.endsTo = datesToISO(data.endsTo) || "";

  const formData = new FormData();

  // Append non-attribute fields to formData
  for (let key in data) {
    if (
      key.includes("attribute") ||
      key === "allRequiredAmount" ||
      key === "currentPaidAmount"
    ) {
      continue;
    }
    formData.append(key, data[key]);
  }

  formData.append("allRequiredAmount", data.allRequiredAmount || "");
  formData.append("currentPaidAmount", data.currentPaidAmount || "");

  // Process and append attribute fields to formData
  await processGiftCardAttributes(data, formData);

  // Remove temporary fields from data
  [
    "attributeTitle",
    "attributeAmount",
    "attributeImage",
    "attributeGiftingCardDesigns",
  ].forEach((field) => delete data[field]);

  return api.put(
    `/api/adminGiftProject/gift-projects/${data.id}`,
    formData,
    formHeaders,
  );
};
